import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bf1fe064")

_pushScopeId("data-v-bf1fe064")
const _hoisted_1 = { class: "set-box" }
const _hoisted_2 = { class: "set-item" }
const _hoisted_3 = { class: "set-th" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "set-th-title theme-all" }, "目前主题", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icons = _resolveComponent("icons")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_icons, {
      name: "set",
      className: "set-svg",
      class: "theme-all"
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", {
          class: "th-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.colorChange(1)))
        }, "切换主题1"),
        _createVNode("div", {
          class: "th-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.colorChange(2)))
        }, "切换主题2"),
        _createVNode("div", {
          class: "th-3",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.colorChange(3)))
        }, "切换主题3"),
        _createVNode("div", {
          class: "th-more",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.colorChange(4)))
        }, "更多主题"),
        _hoisted_5
      ]),
      _createVNode("div", {
        class: "theme-all cancat-btn",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goEvent && _ctx.goEvent(...args)))
      }, " 联 系 我 们 ")
    ])
  ]))
})